"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/site-menu/component");
const component_2 = require("@front/layouts/default-layout/component");
const WSService_audio_1 = __importStar(require("@front/services/WSService.audio"));
const console_1 = require("@rws-framework/console");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="knowledge-list-page">  
    
    <crud-table ${(0, fast_element_1.ref)('crudTable')} :isItemUneditable="${x => x.isKnowledgeUneditable}" :forceItemEditable="${x => x.forceKnowledgeEditable}" :onDataLoaded="${x => x.onDataLoaded}" addText="${'route.knowledge.create'.t()}" resource="knowledge"
      searchPlaceholder="Search knowledge..." indexEndpoint="knowledge.index" listEndpoint="knowledge.list"
      deleteEndpoint="knowledge.delete" editRoute="/ai/knowledge/edit/:id" previewRoute="/ai/knowledge/preview/:id" addRoute="/ai/knowledge/create"
      :columns="${x => x.tableColumns}">
      <div slot="custom-filters" style="width: 100%;" class="mt-2">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">             
              <select 
                class="form-control"
                :value="${x => x.selectedAvatarId}"
                @change="${(x, c) => { x.selectedAvatarId = c.event.target.value; x.onAvatarFilterChange(); }}">
                ${(0, fast_element_1.repeat)(x => x.avatarOptions, (0, fast_element_1.html) `
                  <option value="${opt => opt.value}" ?selected="${(opt, c) => opt.value === c.parent.selectedAvatarId}">
                    ${opt => opt.label.includes('knowledge.filter.all_avatars') ? opt.label.t() : opt.label}
                  </option>
                `)}
              </select>
            </div>
          </div>
          <div class="col-md-8">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="assignedOnlyFilter" :checked="${x => x.showAssignedOnly}" 
                     @change="${(x, c) => { x.showAssignedOnly = c.event.target.checked; x.onAssignedFilterChange(); }}">
              <label class="form-check-label" for="assignedOnlyFilter">
                ${'knowledge.filter.assigned_only'.t()}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div slot="extra-buttons">
         <button type="button" class="btn btn-outline-secondary mr-2" @click="${x => x.manageProjects()}">
            <i class="fas fa-layer-group"></i> ${'project.manage'.t()}
        </button>
        <button type="button" class="btn btn-outline-primary" @click="${x => x.bulkUpload()}">
            <i class="fas fa-cloud-upload-alt"></i> ${'knowledge.bulk_upload.button'.t()}
        </button>
      </div>
    </crud-table>
  </div>
</div>`;
const styles = null;
const shadowOptions = { "mode": "open" };
let KnowledgeList = class KnowledgeList extends client_1.RWSViewComponent {
    constructor(wsService) {
        super();
        this.wsService = wsService;
        this.showAssignedOnly = false;
        this.selectedAvatarId = '';
        this.avatarOptions = [];
        this.ragProgress = {};
        this.tableColumns = [
            {
                key: 'title',
                header: 'knowledge.title'.t(),
                formatter: (title, row) => {
                    let html = `<div><strong>${title}</strong>`;
                    if (row.tags && row.tags.length > 0) {
                        html += '<br>';
                        html += row.tags.map((tag) => `<span class="badge badge-secondary badge-sm mr-1 mt-1">${tag}</span>`).join('');
                    }
                    html += '</div>';
                    return html;
                }
            },
            {
                key: 'contentType',
                header: 'knowledge.form.content_type.label'.t(),
                formatter: (contentType) => {
                    return contentType ? `<div class="text-center"><span class="badge badge-warning">${(`knowledge.form.contentType.` + contentType).t()}</span></div>` : '-';
                }
            },
            {
                key: 'project',
                header: 'knowledge.project'.t(),
                formatter: (group) => {
                    if (!group)
                        return '-';
                    return group ? group.name : '-';
                }
            },
            {
                key: 'native',
                header: 'knowledge.native'.t(),
                formatter: (native) => native ? '<span class="badge badge-warning">Native</span>' : '-'
            },
            {
                key: 'ragStatus',
                header: 'knowledge.ragStatus'.t(),
                formatter: (status, row) => {
                    let badgeClass = 'secondary';
                    switch (status) {
                        case backendImport_1.KnowledgeRAGStatus.NOT_INDEXED:
                            badgeClass = 'success';
                            break;
                        case backendImport_1.KnowledgeRAGStatus.PROCESSING:
                            badgeClass = 'info';
                            break;
                        case backendImport_1.KnowledgeRAGStatus.COMPLETED:
                            badgeClass = 'success';
                            break;
                        case backendImport_1.KnowledgeRAGStatus.FAILED:
                            badgeClass = 'danger';
                            break;
                    }
                    const extraInfo = status === backendImport_1.KnowledgeRAGStatus.PROCESSING ? this.showPercentage(row.id) : '';
                    const reindexBtn = status === backendImport_1.KnowledgeRAGStatus.FAILED ? `<rws-tooltip class="ml-1" text="${'knowledge.reindex'.t()}"><button class="btn btn-sm btn-info reindex-btn" data-id="${row.id}"><i class="simple-icon-reload"></i></button></rws-tooltip>` : '';
                    return `<span class="badge badge-${badgeClass}">${(`knowledge.ragStatus.` + status).t()}${extraInfo}</span>${reindexBtn}`;
                }
            },
            {
                key: 'assigned',
                header: 'knowledge.assigned'.t(),
                formatter: (value, row) => {
                    const isAssigned = (row.avatarKnowledge && row.avatarKnowledge.length > 0) ||
                        (row.professionKnowledge && row.professionKnowledge.length > 0);
                    const badgeClass = isAssigned ? 'success' : 'danger';
                    const text = isAssigned ? 'common.yes'.t() : 'common.no'.t();
                    return `<span class="badge badge-${badgeClass}">${text}</span>`;
                }
            },
            {
                key: 'createdAt',
                header: 'knowledge.createdAt'.t(),
                formatter: (value, row) => {
                    return value ? console_1.DateUtils.create(value).format('dd.MM.yyyy HH:mm') : '-';
                }
            },
        ];
        this.statusListenerCallBacks = [];
        this.isWebsocketListenerActive = false;
        this.loadAvatars();
    }
    async connectedCallback() {
        var _a, _b, _c;
        const isSuperAdmin = ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
        const isParentUser = ((_b = component_2.DefaultLayout.USER) === null || _b === void 0 ? void 0 : _b.role) === backendImport_1.UserRoles.PARENT_USER || ((_c = component_2.DefaultLayout.USER) === null || _c === void 0 ? void 0 : _c.role) === backendImport_1.UserRoles.ENTERPRISE;
        if (!isSuperAdmin) {
            this.isKnowledgeUneditable = (row) => row.native === true;
            this.forceKnowledgeEditable = (row) => {
                var _a, _b;
                if (!row.creator) {
                    return false;
                }
                console.log({ knowledgeCreator: row.creator.id === ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.id) });
                return row.creator.id === ((_b = component_2.DefaultLayout.USER) === null || _b === void 0 ? void 0 : _b.id);
            };
            console.log({ forceKnowledgeEditable: this.forceKnowledgeEditable });
        }
        if (isParentUser || isSuperAdmin) {
            this.tableColumns.push({
                key: 'creator',
                header: 'knowledge.creator'.t(),
                formatter: (creator) => creator ? `<a class="creator-link" data-id="${creator.id}" href="/user/list/${creator.id}">${creator.name}</a>` : '-'
            });
            this.tableColumns.push({
                key: 'active',
                header: 'resource.active'.t(),
                formatter: (active) => `<span class="badge badge-${active || active === null || active === undefined ? 'success' : 'danger'}">${active || active === null || active === undefined ? 'Active' : 'Inactive'}</span>`
            });
        }
        super.connectedCallback();
        // Set up websocket listener only once
        if (!this.isWebsocketListenerActive) {
            this.isWebsocketListenerActive = true;
            this.statusListenerCallBacks.push(this.wsService.listenForMessage('status_update', (response) => {
                if (response.data.status && response.data.knowledgeId) {
                    if (response.data.status === 'knowledge.progress' && response.data.percentage !== undefined) {
                        this.ragProgress = {
                            ...this.ragProgress,
                            ['rag_progress_' + response.data.knowledgeId]: { images: response.data.images || false, percentage: response.data.percentage }
                        };
                        return;
                    }
                    if (response.data.status === 'knowledge.error') {
                        // this.notifyService.notify('rag.file.indexing_error'.t(), 'error');
                    }
                    this.crudTable.loadData();
                }
            }, 'rag_processing_update'));
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        // Clean up websocket listeners
        for (const cb of this.statusListenerCallBacks) {
            if (cb) {
                cb();
            }
        }
        // Reset websocket listener flag
        this.isWebsocketListenerActive = false;
        this.statusListenerCallBacks = [];
    }
    showPercentage(knowledgeId) {
        var _a, _b;
        const percentage = (_a = this.ragProgress['rag_progress_' + knowledgeId]) === null || _a === void 0 ? void 0 : _a.percentage;
        const imagesLabel = ((_b = this.ragProgress['rag_progress_' + knowledgeId]) === null || _b === void 0 ? void 0 : _b.images) ? (' ' + 'knowledge.statusInfo.images'.t()) : '';
        return percentage !== undefined ? `${imagesLabel}: ${percentage.toFixed(2)}%` : '';
    }
    onDataLoaded(data, totalPages, element) {
        if (data.length) {
            setTimeout(() => {
                const creators = element.shadowRoot.querySelectorAll('a.creator-link');
                creators.forEach(creator => {
                    creator.onclick = (e) => {
                        e.preventDefault();
                        component_1.SiteMenu.goto.bind(this)(`/user/list/${creator.dataset.id}`);
                    };
                });
                const reindexElements = element.shadowRoot.querySelectorAll('button.reindex-btn');
                reindexElements.forEach(reindexBtn => {
                    reindexBtn.onclick = (e) => {
                        e.preventDefault();
                        this.apiService.back.get('knowledge.reindex', { routeParams: { id: reindexBtn.dataset.id } }).then(() => {
                            this.notifyService.notify('knowledge.reindexingStarted'.t());
                        });
                    };
                });
            }, 0);
        }
    }
    manageProjects() {
        // Navigate to dedicated project management page
        component_1.SiteMenu.goto.bind(this)('/ai/knowledge/projects');
    }
    bulkUpload() {
        // Navigate to bulk upload page
        component_1.SiteMenu.goto.bind(this)('/ai/knowledge/bulk-upload');
    }
    onAssignedFilterChange() {
        const crudTable = this.$('crud-table');
        if (crudTable) {
            // Update the query parameters for the crud table
            const queryParams = {};
            if (this.showAssignedOnly)
                queryParams.assigned = '1';
            if (this.selectedAvatarId)
                queryParams.avatarId = this.selectedAvatarId;
            crudTable.customQueryParams = queryParams;
            crudTable.loadData();
        }
    }
    onAvatarFilterChange() {
        const crudTable = this.$('crud-table');
        if (crudTable) {
            // Update the query parameters for the crud table
            const queryParams = {};
            if (this.showAssignedOnly)
                queryParams.assigned = '1';
            if (this.selectedAvatarId)
                queryParams.avatarId = this.selectedAvatarId;
            crudTable.customQueryParams = queryParams;
            crudTable.loadData();
        }
    }
    async loadAvatars() {
        try {
            // Use the same query parameter as avatar list to get complete data
            const response = await this.apiService.back.get('avatar.list', {
                queryParams: { widget: '1' }
            });
            if (response && response.success && Array.isArray(response.data)) {
                this.avatarOptions = [
                    { label: 'knowledge.filter.all_avatars', value: '' },
                    ...response.data.map((avatar) => ({
                        label: avatar.name,
                        value: avatar.id
                    }))
                ];
            }
            else {
                console.error('Failed to load avatars:', response === null || response === void 0 ? void 0 : response.error);
            }
        }
        catch (error) {
            console.error('Failed to load avatars:', error);
        }
    }
};
exports.KnowledgeList = KnowledgeList;
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], KnowledgeList.prototype, "isKnowledgeUneditable", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], KnowledgeList.prototype, "forceKnowledgeEditable", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], KnowledgeList.prototype, "showAssignedOnly", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], KnowledgeList.prototype, "selectedAvatarId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof Array !== "undefined" && Array) === "function" ? _b : Object)
], KnowledgeList.prototype, "avatarOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof Record !== "undefined" && Record) === "function" ? _c : Object)
], KnowledgeList.prototype, "ragProgress", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], KnowledgeList.prototype, "tableColumns", void 0);
exports.KnowledgeList = KnowledgeList = __decorate([
    (0, client_1.RWSView)('knowledge-list', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(WSService_audio_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof WSService_audio_1.WSServiceAudioInstance !== "undefined" && WSService_audio_1.WSServiceAudioInstance) === "function" ? _a : Object])
], KnowledgeList);
KnowledgeList.defineComponent();
